import { Box, Typography } from "@mui/material";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { hubAction } from "redux/slice/hub";
import ScrollToBottom from "utils/ScrollToBottom";
import Report from "./Report";

const Reports = ({ user, reports, isMobileDisplay, scrollToBottom }) => {
  const dispatch = useDispatch();
  const bottomRef = useRef(null);
  const isInitialLoad = useRef(true);
  const containerRef = useRef(null);

  useEffect(() => {
    if (isInitialLoad.current && reports && reports.length > 0) {
      bottomRef.current?.scrollIntoView({ behavior: "auto", block: "nearest" });
      isInitialLoad.current = false;
    }
  }, [reports]);

  useEffect(() => {
    dispatch(hubAction.removeNotifications({ key: "reports" }));
  }, []);

  return (
    <Box ref={containerRef} className="hub-content-window" sx={{ padding: "1rem 0" }}>
      {reports && reports.length > 0 ? (
        reports.map((report) => (
          <Box key={report.id} className="markdown-table">
            <Report report={report} user={user} />
          </Box>
        ))
      ) : (
        <Typography sx={{ textAlign: "left", fontSize: "1rem", ml: "2rem", mt: "1rem" }}>
          No reports to display
        </Typography>
      )}
      <Box ref={bottomRef} />
      <ScrollToBottom
        containerRef={containerRef}
        onClick={() => scrollToBottom(bottomRef)}
        isMobileDisplay={isMobileDisplay}
      />
    </Box>
  );
};

export default Reports;
